import { ServiceContainer } from "@/services/backend/qpm/calculations/types/calculation";
import { CalculationServiceType } from "@/services/backend/qpm/calculations/types/calculation-enum";
import { Value } from "@/shared/components/domain/qpm/inputs/number-input";
import { EditRevenueComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/edit-revenue-component";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";

export type TargetRevenueComponentProps = {
  calculationId: string;
  serviceGroup: ServiceContainer;
  serviceTypeKey: CalculationServiceType;
};

export function TargetRevenueComponent({
  calculationId,
  serviceGroup,
  serviceTypeKey,
}: TargetRevenueComponentProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2">
        <Label htmlFor="sg-revenue">{t("Umsatz pro Stunde")}</Label>
        <Value
          id="sg-revenue"
          value={serviceGroup.targetRevenue}
          fractions={2}
        />
      </div>
      <EditRevenueComponent
        calculationId={calculationId}
        serviceGroup={serviceGroup}
        serviceTypeKey={serviceTypeKey}
      />
    </div>
  );
}
